module.exports = __webpack_public_path__ + "media/images/country_flags/ua-c0fefeb30ebd22dd682d1387dca1f6ee.png";